var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-col"},[(_vm.project)?_c('progress-photovoltaic-park',{ref:"refProgressPhotovoltaicPark",attrs:{"projectId":_vm.project.id,"can-actions-pictogram":_vm.canActionsPictogram}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }